import AttachFileIcon from '@mui/icons-material/AttachFile';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Button, Checkbox, CircularProgress, IconButton } from '@mui/material';
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import _ from "lodash";
import pluralize from 'pluralize';
import { useContext, useEffect, useState } from "react";
import { DialogsContext } from '../contexts';
import { courseDetailApi } from './courseDetail.queries';
import CourseDetailRow from './courseDetail.row';

const CHUNK_SIZE = 25;

export default function CourseDetailTable(props) {
	let { course, courseDetails } = props;
	const useDelete = courseDetailApi.useDelete();
	const [visibleCount, setVisibleCount] = useState(CHUNK_SIZE);
	const [selected, setSelected] = useState([]);
	const [expandAll, setExpandAll] = useState(null);
	const { dialogs } = useContext(DialogsContext);

	//Force "null" instead of "undefined"
	_.forEach(courseDetails, courseDetail => {
		courseDetail.parentId = courseDetail.parentId ? courseDetail.parentId : null;
	});
	const groups = _.groupBy(courseDetails, 'parentId');
	const rows = _.sortBy(groups['null'], 'ordinal');
	const visibleRows = _.slice(rows, 0, visibleCount);

	useEffect(() => {
		if (visibleCount >= rows.length) {
			return;
		}

		const loadMore = () => {
			setVisibleCount((prev) => Math.min(prev + CHUNK_SIZE, rows.length));
		};

		const idleCallback = () => {
			loadMore();
			if ((visibleCount + CHUNK_SIZE) < rows.length) {
				requestIdleCallback(idleCallback);
			}
		};

		requestIdleCallback(idleCallback);
	}, [visibleCount, rows.length]);

	const toggleSelected = (id) => {
		const index = selected.indexOf(id);
		if (index === -1) {
			selected.push(id);
		} else {
			selected.splice(index, 1);
		}
		setSelected([...selected]);
	};

	const toggleSelectAll = () => {
		console.log(selected);
		if (selected?.length < courseDetails?.length) {
			setSelected(_.map(courseDetails, 'id'));
		}
		else {
			setSelected([]);
		}
	};

	const onDelete = async () => {
		await useDelete.mutateAsync({ courseId: course.id, id: selected.join(',') });
		setSelected([]);
	};

	return (
		<TableContainer component={Paper} sx={{ pb: 2, overflow: 'visible' }}>
			<Table>
				<TableHead>
					<TableRow>
						<TableCell padding="checkbox" sx={{pl:0}}>
							<Checkbox indeterminate={selected?.length > 0 && selected?.length < courseDetails?.length} checked={courseDetails?.length > 0 && selected?.length === courseDetails?.length} onChange={(e) => toggleSelectAll()} />
						</TableCell>
						<TableCell sx={{pl:0}}>
							<IconButton onClick={() => setExpandAll(!expandAll)}>
								{expandAll ? <KeyboardArrowUpIcon fontSize="inherit" /> : <KeyboardArrowDownIcon fontSize="inherit" />}
							</IconButton>
						</TableCell>
						<TableCell>{courseDetails?.[0]?.type}</TableCell>
						<TableCell>Description</TableCell>
						<TableCell title="Attachments"><AttachFileIcon sx={{ fontSize: 16 }} /></TableCell>
						<TableCell>More</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{visibleRows.length > 0 && visibleRows.map(courseDetail =>
						<CourseDetailRow course={course} courseDetail={courseDetail} groups={groups} depth={0} key={courseDetail.id} expandAll={expandAll}>
							<Checkbox checked={selected.indexOf(courseDetail.id) >= 0} onChange={() => toggleSelected(courseDetail.id)} />
						</CourseDetailRow>
					)}
					{visibleRows?.length < rows?.length &&
						<TableRow>
							<TableCell colSpan={6} sx={{ py: 2, textAlign: 'center' }}>
								<CircularProgress size={20} />
							</TableCell>
						</TableRow>
					}
				</TableBody>
				{courseDetails?.length == 0 &&
					<TableFooter>
						<TableRow>
							<TableCell sx={{ border: 0 }}></TableCell>
							<TableCell sx={{ border: 0, pt: 2 }} colSpan={4}>
								<Button variant="contained" color="primary" onClick={(e) => { dialogs.open('courseDetail' + (courseDetails.length ? '' : 'Wizard'), { courseId: course?.id, type: courseDetails?.length ? courseDetails[0].type : null, parentId: null, ordinal: (courseDetails.length + 1) }) }}>{courseDetails?.length ? 'Add More ' + pluralize(courseDetails[0].type) : 'Add Coursework'}</Button>
							</TableCell>
						</TableRow>
					</TableFooter>
				}
				{selected?.length > 0 &&
					<TableFooter>
						<TableRow>
							<TableCell sx={{ border: 0 }}></TableCell>
							<TableCell sx={{ border: 0, pt: 2 }} colSpan={4}>
								<Button variant="outlined" color="error" onClick={onDelete}>Delete</Button>
							</TableCell>
						</TableRow>
					</TableFooter>
				}
			</Table>
		</TableContainer>
	);
}

//export default React.memo(CourseDetailTable);